import { Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { Navigate, useNavigate } from "react-router-dom";
import PsContext from "../../context";
import {
  APP_TYPE,
  MOB_ICONS,
  formToObject,
  integerIndMobile,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import MobileLoginPass from "./mobileLoginPass";
import MobileOtpVerify from "./mobileOtpVerify";

const LoginWithOtp = (props) => {
  const context = useContext(PsContext);

  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  const [validated, setValidated] = useState(false);

  const [serverResponse, setServerResponse] = useState("");

  useEffect(() => {
    //context.loadSettings();
    if (context.mobilePass.length < 1)
      context.setStorage("mob_attendance_date", "");
  }, []);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    if (APP_TYPE != "SAAS") {
      checkLogin(form);
      return;
    }
    let fx = formToObject(form);
    const f = new FormData();
    f.append("username", fx.mobile_no + "@" + context.dbPostfix);
    axios.post(ServiceUrl.LOGIN_V2.CHECK, f).then((res) => {
      if (res["data"].status == "1") {
        axios.defaults.headers.common["Api-Token"] = `${res["data"].api}`;
        //setRedirect(res["data"].data);
        checkLogin(form);
      } else {
        Toast.show({
          content: res["data"].message || "Error",
          position: "top",
        });
        setLoader(false);
      }
    });
  };

  const checkLogin = (form) => {
    setLoader(true);
    axios
      .post(ServiceUrl.MOB.CHECK_USERNAME, new FormData(form))
      .then((res) => {
        if (res["data"].status == "1") {
          context.updateMobileUserId(res["data"].data);
          setServerResponse(res["data"].data);
        } else {
          //toast.error(res["data"].message || "Error");
          Toast.show({
            content: res["data"].message || "Error",
            position: "top",
          });
        }
        setLoader(false);
      });
  };

  if (context.logged == "yes") {
    //history.push("/app");
    return <Navigate to="/staff/app" replace={true} />;
    return null;
  } else if (context.mobileUserId.length > 4 && context.mobilePass.length > 2) {
    return <MobileLoginPass />;
  } else if (serverResponse && serverResponse.length > 0) {
    return (
      <MobileOtpVerify
        onReset={(e) => setServerResponse([])}
        staffUuid={serverResponse}
      />
    );
  } else {
    return (
      <>
        <div className="page-content-wrapper">
          <div className="container-sm" data-aos="zoom-in">
            <div className="border-0">
              <div className="login-img d-flex justify-content-center align-content-center">
                <img
                  className="theme-login-img"
                  src={MOB_ICONS.MAN_256}
                  style={{ width: "100%", maxWidth: "120px" }}
                />
              </div>
              <div className="login my-4">
                <h2 className="fw-bold text-center">Login</h2>
                <p className="text-center">Enter your mobile to continue</p>
              </div>
            </div>

            <div className="px-3">
              <Form
                action=""
                method="post"
                noValidate
                validated={validated}
                onSubmit={handleFormSubmit}
              >
                <input type="hidden" name="device_name" value={"kalvisalai"} />
                <input
                  type="hidden"
                  name="device_build_id"
                  value={"kalvisalai"}
                />
                <input
                  type="hidden"
                  name="emp_mobile_password"
                  value={context.mobPass}
                />
                <Row className="mt-3">
                  <Col md={12}>
                    <Form.Control
                      type="number"
                      name="mobile_no"
                      className="fw-bold"
                      size="lg"
                      placeholder="Mobile Number"
                      onKeyPress={integerIndMobile}
                      autoFocus
                      required
                    />
                    <Form.Control.Feedback type="invalid">
                      Mobile Number is required
                    </Form.Control.Feedback>
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col md={12}>
                    <Button
                      type="submit"
                      variant="danger"
                      className="btn-block border-0 text-uppercase bg-theme"
                      size="lg"
                      disabled={loader}
                    >
                      {loader ? "Validating..." : "Continue"}
                      {loader && (
                        <Spinner
                          animation="grow"
                          size="sm"
                          state="loading"
                          className="ms-3"
                        />
                      )}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </>
    );
  }
};
export default LoginWithOtp;
